import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../shared/PRE-LOAD/app-settings';
import { ReservationService } from '../../../shared/services/reservation/reservation.service';
import { UserSelectionsService } from '../../../shared/services/user-selections/user-selections.service';
import { Product } from '../../../shared/types/product.type';
import { Journey, JourneySteps } from '../../../shared/types/strings.type'
import { JourneyConfig } from '../../config/journey';
import { AnalyticsService } from '../../../shared/services/analytics/analytics.service';


@Component({
    selector: 'event-confirmation',
    templateUrl: './event-confirmation.component.html',
    styleUrls: ['./event-confirmation.component.scss', '../../styles.event.scss']
})
export class EventConfirmationComponent implements OnInit {

    constructor(
        private router: Router,
        private userSelectionService: UserSelectionsService,
        private reservationService: ReservationService,
        private appSettings: AppSettings,
        private analytics: AnalyticsService
    ) {
    }

    showSubmit: boolean;
    journeySteps: Array<JourneySteps> = JourneyConfig.steps;
    event: Product;
    startTime: Date;
    header: Journey = {
        title: 'Your appointment has been booked',
        instruction: `A confirmation email has been sent to you`
    };
    rttdContent = {
        title: 'Test drive a BMW vehicle'
    }

    ngOnInit() {
        this.event = this.userSelectionService.get('product');
        this.startTime = this.userSelectionService.get('startTime');

        this.analytics.setFormStep('Personal Details');

    }

    currentDayCount($event) {
        this.showSubmit = $event.days > 1;
    }

    viewAllListings() {
        this.router.navigate(['select-model'], { skipLocationChange: true });
    }

    scrollToId(id): void {
        let element = document.getElementById(id);
        console.log(element);
        element.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
      }

 /**
     * @description Navigate to the booking cancellation page.
     *
     * Get the reservation from the reservationService and navigate to the cancellation page.
     * The reservation service is the store for reservations.
     */
  cancelBooking() {
    this.reservationService.$reservation.subscribe(reservation => {
        this.router.navigate(['/cancel-booking', reservation.id], {
            skipLocationChange: true
        });
    });
}
}
